import React from "react";

const CfaSvg = ({ fill = "#B0B3C7", width = "14px", height = "14px" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_2569_26193)">
        <path
          d="M0.000115458 3.79193C0.000115458 3.55986 0.0923027 3.3373 0.256397 3.17321C0.420491 3.00912 0.643051 2.91693 0.875116 2.91693H10.5001V1.42884C10.4995 1.31601 10.5324 1.20555 10.5947 1.11142C10.6569 1.01729 10.7456 0.943717 10.8496 0.90001C10.9536 0.856303 11.0683 0.844423 11.1791 0.865872C11.2898 0.887321 11.3918 0.941136 11.4719 1.02051L13.8117 3.32934C13.8714 3.38828 13.9188 3.45848 13.9512 3.53589C13.9836 3.6133 14.0002 3.69636 14.0002 3.78026C14.0002 3.86416 13.9836 3.94723 13.9512 4.02463C13.9188 4.10204 13.8714 4.17225 13.8117 4.23118L11.4719 6.54059C11.3917 6.61969 11.2897 6.67325 11.1791 6.69454C11.0684 6.71583 10.9539 6.70389 10.85 6.66023C10.7461 6.61657 10.6574 6.54315 10.5951 6.44919C10.5329 6.35524 10.4998 6.24497 10.5001 6.13226V4.66693H0.875116C0.643051 4.66693 0.420491 4.57474 0.256397 4.41065C0.0923027 4.24655 0.000115458 4.02399 0.000115458 3.79193ZM13.1251 9.3336H3.50012V7.84551C3.50068 7.73268 3.46778 7.62222 3.40557 7.52809C3.34336 7.43395 3.25464 7.36038 3.15061 7.31668C3.04659 7.27297 2.93195 7.26109 2.82117 7.28254C2.7104 7.30399 2.60847 7.3578 2.52828 7.43718L0.188532 9.74835C0.128813 9.80728 0.0813949 9.87748 0.0490304 9.95489C0.016666 10.0323 0 10.1154 0 10.1993C0 10.2832 0.016666 10.3662 0.0490304 10.4436C0.0813949 10.521 0.128813 10.5912 0.188532 10.6502L2.52828 12.9596C2.60847 13.0386 2.71022 13.0921 2.82073 13.1135C2.93125 13.1348 3.04561 13.123 3.14944 13.0796C3.25328 13.0361 3.34196 12.963 3.40436 12.8693C3.46675 12.7756 3.50006 12.6656 3.50012 12.553V11.0836H13.1251C13.3572 11.0836 13.5797 10.9914 13.7438 10.8273C13.9079 10.6632 14.0001 10.4407 14.0001 10.2086C14.0001 9.97653 13.9079 9.75397 13.7438 9.58988C13.5797 9.42578 13.3572 9.3336 13.1251 9.3336Z"
          fill={fill}
        />
      </g>
      <defs>
        <clipPath id="clip0_2569_26193">
          <rect width="14" height="14" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CfaSvg;
